import DataLayer from "./DataLayer";

export default ({ basketId, items }) => {
    DataLayer.track({
        event: "checkout",
        ecommerce: {
            basket: { id: basketId },
            checkout: {
                products: DataLayer.getProducts(items),
            },
        },
    });
};
